module.exports = __webpack_public_path__ + "img/excel.e6a68e32.svg";